import { createSlice } from '@reduxjs/toolkit';
import { uploadImage } from '../thunks/imgThunks';

interface ImageState {
  uploadLoading: boolean;
  uploadError: string | null;
  uploadSuccess: boolean;
  lastUploadedUrl: string | null;
}

const initialState: ImageState = {
  uploadLoading: false,
  uploadError: null,
  uploadSuccess: false,
  lastUploadedUrl: null,
};

const imageSlice = createSlice({
  name: 'image',
  initialState,
  reducers: {
    clearImageMessages: (state) => {
      state.uploadError = null;
      state.uploadSuccess = false;
      state.lastUploadedUrl = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(uploadImage.pending, (state) => {
        state.uploadLoading = true;
        state.uploadError = null;
        state.uploadSuccess = false;
      })
      .addCase(uploadImage.fulfilled, (state, action) => {
        state.uploadLoading = false;
        state.uploadSuccess = true;
        state.lastUploadedUrl = action.payload.data?.imageUrl || null;
      })
      .addCase(uploadImage.rejected, (state, action) => {
        state.uploadLoading = false;
        state.uploadError = action.payload || 'Upload failed';
        state.uploadSuccess = false;
      });
  },
});

export const { clearImageMessages } = imageSlice.actions;
export default imageSlice.reducer;
